angular.module('impactx.panel').controller('CompanyPreviewPanelCtrl', [
    '$scope',
    'TranslationService',
    'ImageEditor',
    CompanyPreviewPanelCtrl]);

function CompanyPreviewPanelCtrl($scope, TranslationService, ImageEditor) {
    var self = this;

    self.$onInit = function () {
        if(!self.trns) {
            self.trns = {};
        }

        if (self.mode) {
            self.trns[self.mode] = TranslationService.get(self.mode);
        }
    };

    self.deleteImage = function(event) {
        if(event) {
            event.stopPropagation();
            event.preventDefault();
        }
        self.image.isDeleted = true;
        self.image.file = undefined;
        self.image.url = "img/missing-image.jpg";
    };

    self.openEditor = function (event, currentImage, newImage) {
        var imageAreaType = self.mode == 'supplier' ? 'circle' : 'square';
        ImageEditor.open(event, currentImage, newImage, imageAreaType).then(function (croppedImage) {
            self.image.file = croppedImage.image;
            self.image.fileName = croppedImage.name;
            self.image.isDeleted = true;
        })
    };

    $scope.$watch(function() {
        return impactX.isDefined(self, "image.file");
    }, function(newValue, oldValue) {
        if(newValue && !angular.equals(newValue, oldValue)) {
            self.image.isDeleted = true;
        }
    });
}